import { createContext, useContext, useState, useEffect, useRef } from "react";
import { auth, googleProvider } from "./Firebase.jsx";
import { onAuthStateChanged, signInWithPopup, signInWithRedirect, getRedirectResult, signOut } from "firebase/auth";
import { useCounter } from '@MyLib/System/useCounter.js';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const isInit = useRef(false);
	const running = useCounter();
	const [user, setUser] = useState();

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
			if (currentUser) {
				setUser(currentUser);
				//setUser({
				//	uid: currentUser.uid,
				//	displayName: currentUser.displayName || "Guest",
				//	email: currentUser.email,
				//});
			} else {
				setUser(null);
			}

			if (!isInit.current) {
				isInit.current = true;
				//stopRunning();
			}
		});
		return () => unsubscribe();
	}, []);

	useEffect(() => {
		getRedirectResult(auth).then((result) => {
		});
	}, []);

	const login = async () => {
		try {
			if (process.env.NODE_ENV === "development" && process.env.FIREBASE_EMULATOR === "true")
			{
				const result = await signInWithPopup(auth, googleProvider);
			}
			else
			{
				await signInWithRedirect(auth, googleProvider);
			}
		}
		catch (error) {
			console.error("Link error:", error);
		}
	};

	const logout = async () => {
		running.inc();

		try {
			await signOut(auth);
		}
		catch (err) {
			console.error(err);
		}
		finally {
			stopRunning();
		}
	};

	const deleteUser = async () => {
		running.inc();

		try {
			await user.delete();
		}
		catch (err) {
			console.error(err);
		}
		finally {
			running.dec();
		}
	};

	return (
		<AuthContext.Provider value={{
			user,
			auth,
			running: running.active,
			login,
			logout,
			deleteUser
		}}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
